// extracted by mini-css-extract-plugin
module.exports = {"container":"countdown-message_container__sPx7c","time":"countdown-message_time__DE6vs"};